import contextSectionNavigation from '@contexts/sectionNavigation'
import { FunctionComponent, useContext } from 'react'
import styled from 'styled-components'
import { ImageSubsectionProps } from '@widgets/SectionNavigation/types'

const { SectionNavigationContext } = contextSectionNavigation

interface StyledImageSubsectionProps {
  isMondovino: boolean
}

const StyledImageSubsection = styled.img<StyledImageSubsectionProps>`
  max-height: ${({ isMondovino }) => (isMondovino ? '42px' : '20px')};
  object-fit: cover;
`

const ImageSubsectionComponent: FunctionComponent<ImageSubsectionProps> = ({
  children,
}) => {
  const { isMondovino } = useContext(SectionNavigationContext)
  const { imageUrl } = children

  return (
    <StyledImageSubsection
      isMondovino={isMondovino}
      src={imageUrl}
      alt="Subsection logo"
      loading="lazy"
    />
  )
}

export default ImageSubsectionComponent
